import { render, staticRenderFns } from "./diaoboDetail.vue?vue&type=template&id=b2fb6426&scoped=true&"
import script from "./diaoboDetail.vue?vue&type=script&lang=js&"
export * from "./diaoboDetail.vue?vue&type=script&lang=js&"
import style0 from "./diaoboDetail.vue?vue&type=style&index=0&id=b2fb6426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fb6426",
  null
  
)

export default component.exports